import React from 'react';
import Dropdown from './Dropdown';
import countries from '../../data/countries.json';
import { states } from '../../data/constants';

export const EMPTY_ADDRESS = { country: { name: '', code: '' }, state: { name: '', tax: 5 }, city: '', address: '', zipCode: '' };

export const toAddressForm = (addr) => ({
    country: { name: addr?.country?.name || '', code: addr?.country?.code || '' },
    state: { name: addr?.state?.name || '', tax: addr?.state?.tax ?? 5 },
    city: addr?.city || '',
    address: addr?.address || '',
    zipCode: addr?.zipCode || '',
});

const countryOptions = countries.map((c) => ({ value: c.code, label: c.name }));
const provinceOptions = states.map((s) => ({ value: s.tax, label: s.name }));

/** Country, province, city, street and postal code, in the canonical { name, code } / { name, tax } shape. */
const AddressFields = ({ value, onChange, disabled }) => {
    const set = (patch) => onChange({ ...value, ...patch });
    const isCanada = value.country.name === 'Canada';

    return (
        <div className="stgFormGrid">
            <div className="stgFormGroup">
                <label className="stgLabel">Country</label>
                <Dropdown
                    options={countryOptions}
                    value={value.country.name ? { value: value.country.code, label: value.country.name } : null}
                    onChange={(opt) => set({ country: { name: opt.label, code: opt.value }, state: { name: '', tax: 5 } })}
                    placeholder="Select country"
                    disabled={disabled}
                />
            </div>
            <div className="stgFormGroup">
                <label className="stgLabel">State / Province</label>
                {isCanada ? (
                    <Dropdown
                        options={provinceOptions}
                        value={value.state.name ? { value: value.state.tax, label: value.state.name } : null}
                        onChange={(opt) => set({ state: { name: opt.label, tax: opt.value } })}
                        placeholder="Select province"
                        disabled={disabled}
                    />
                ) : (
                    <input
                        type="text"
                        className="stgInput"
                        value={value.state.name}
                        onChange={(e) => set({ state: { name: e.target.value, tax: 5 } })}
                        disabled={disabled}
                        placeholder="State / Province"
                    />
                )}
            </div>
            <div className="stgFormGroup">
                <label className="stgLabel">City</label>
                <input
                    type="text"
                    className="stgInput"
                    value={value.city}
                    onChange={(e) => set({ city: e.target.value })}
                    disabled={disabled}
                    placeholder="City"
                />
            </div>
            <div className="stgFormGroup">
                <label className="stgLabel">Postal / ZIP Code</label>
                <input
                    type="text"
                    className="stgInput"
                    value={value.zipCode}
                    onChange={(e) => set({ zipCode: e.target.value })}
                    disabled={disabled}
                    placeholder="Postal / ZIP Code"
                />
            </div>
            <div className="stgFormGroup stgFormFull">
                <label className="stgLabel">Street Address</label>
                <input
                    type="text"
                    className="stgInput"
                    value={value.address}
                    onChange={(e) => set({ address: e.target.value })}
                    disabled={disabled}
                    placeholder="Street address"
                />
            </div>
        </div>
    );
};

export default AddressFields;
